import { Link } from "react-router-dom";
import {
  PATH_PRIVACY_POLICY,
  PATH_TERMS_AND_CONDITIONS,
  PATH_CONTACT,
  PATH_FAQ,
  PATH_ABOUT,
  PATH_ERGOTHERAPIE,
  PATH_NEUROLOGIE_GERIATRIE,
  PATH_PSYCHIATRIE,
  PATH_PEDIATRICS,
  PATH_ADDITIONAL_OFFERS,
  PATH_GROUP_THERAPY,
} from "../../utils/constants";
import { MapPinIcon, PhoneIcon, EnvelopeIcon, ClockIcon } from "@heroicons/react/24/outline";
import { FaInstagram } from "react-icons/fa";
import { ThemeSwitcher } from "../common/ThemeSwitcher";

export const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-800/50 border-t border-gray-100 dark:border-gray-700 transition-colors duration-200 ">
      <div className="mx-auto max-w-7xl ">
        <div className="mx-auto px-6 sm:px-8 lg:px-12">
          {/* Main Footer Content */}
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {/* Column 1: About */}
            <div className="flex flex-col items-start">
              <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-6">
                Über uns
              </h3>
              <div className="space-y-4">
                <Link
                  to={PATH_ABOUT}
                  className="block text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Team
                </Link>
                <Link
                  to={PATH_FAQ}
                  className="block text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  FAQ
                </Link>
                <div className="pt-6">
                  <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">
                    Soziale Netzwerke
                  </h3>
                  <a
                    href="https://www.instagram.com/ergotherapie_rottweil"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                  >
                    <FaInstagram className="h-5 w-5" />
                    <span>Instagram</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Column 2: Services */}
            <div className="flex flex-col items-start">
              <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-6">
                Leistungen
              </h3>
              <div className="space-y-4">
                <Link
                  to={PATH_ERGOTHERAPIE}
                  className="block text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Ergotherapie
                </Link>
                <Link
                  to={PATH_NEUROLOGIE_GERIATRIE}
                  className="block text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Neurologie / Geriatrie
                </Link>
                <Link
                  to={PATH_PSYCHIATRIE}
                  className="block text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Psychiatrie
                </Link>
                <Link
                  to={PATH_PEDIATRICS}
                  className="block text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Pädiatrie
                </Link>
                <Link
                  to={PATH_GROUP_THERAPY}
                  className="block text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Gruppentherapien
                </Link>
                <Link
                  to={PATH_ADDITIONAL_OFFERS}
                  className="block text-base text-gray-600 dark:text-gray-300 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Zusatzangebote
                </Link>
              </div>
            </div>

            {/* Column 3: Contact Info */}
            <div className="flex flex-col items-start">
              <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-6">
                Kontakt & Anfahrt
              </h3>
              <div className="space-y-4 text-base text-gray-600 dark:text-gray-300">
                <div className="flex items-center gap-3">
                  <MapPinIcon className="h-5 w-5 text-ergo-500 dark:text-ergo-400 flex-shrink-0" />
                  <a
                    href="https://www.google.com/maps/place/ERGOTHERAPIE+UND+ZEIT(T)R%C3%84UME/@48.158268,8.6335273,18z/data=!3m2!4b1!5s0x4790a47e64021813:0xdf665faaed8d75e0!4m6!3m5!1s0x4790a594b198b5d1:0xb54763922d777622!8m2!3d48.158268!4d8.6352986!16s%2Fg%2F11vwnz1ddc?entry=ttu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                  >
                    <div>
                      <p>Auf dem Wall 29</p>
                      <p>78628 Rottweil</p>
                    </div>
                  </a>
                </div>

                <div className="flex items-center gap-3">
                  <ClockIcon className="h-5 w-5 text-ergo-500 dark:text-ergo-400 flex-shrink-0" />
                  <div>
                    <p>Mo-Fr: 08.00-18.00</p>
                    <p>Sa: 07.00-17.00</p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <PhoneIcon className="h-5 w-5 text-ergo-500 dark:text-ergo-400 flex-shrink-0" />
                  <a
                    href="tel:+074189698293"
                    className="hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                  >
                    0741 89 69 82 93
                  </a>
                </div>

                <div className="flex items-center gap-3">
                  <EnvelopeIcon className="h-5 w-5 text-ergo-500 dark:text-ergo-400 flex-shrink-0" />
                  <a
                    href="mailto:info@ergo-rw.de"
                    className="hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                  >
                    info@ergo-rw.de
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map removed as per requirements */}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="w-full ">
        <div className="h-full flex flex-col items-center py-8 gap-8">
          {/* Theme Switcher */}
          <div className="flex justify-center">
            <ThemeSwitcher />
          </div>

          {/* Copyright and Links */}
          <div className="w-full px-6 sm:px-8 lg:px-12">
            <div className="grid grid-cols-1 sm:grid-cols-3 items-center gap-6">
              {/* Copyright */}
              <div className="text-sm text-gray-600 dark:text-gray-400 text-center sm:text-left">
                ©2023 - 2024{" "}
                <span className="text-ergo-600 dark:text-ergo-400 font-medium ml-2">ERGOTHERAPIE UND ZEIT(T)RÄUME</span>
              </div>

              {/* Author - Centered */}
              <div className="text-center">
                <p className="font-display text-sm tracking-wide">
                  <span className="text-gray-900 dark:text-white font-playfair italic">Lisa Spreitzer</span>
                </p>
              </div>

              {/* Legal Links */}
              <div className="flex items-center justify-center sm:justify-end gap-8">
                <Link
                  to={PATH_TERMS_AND_CONDITIONS}
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Impressum
                </Link>
                <Link
                  to={PATH_PRIVACY_POLICY}
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-ergo-600 dark:hover:text-ergo-400 transition-colors duration-300"
                >
                  Datenschutzerklärung
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
